import React from 'react';

/** Starts a count-down timer from the given number and returns the current time left */
export const useCountDown = (
  /** Length of the countdown */
  timeMs: number,
  /** Time between steps */
  tickMs = 1000,
): number => {
  const [timeRemaining, setTimeRemaining] = React.useState(timeMs);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeRemaining(prevTime => {
        if (prevTime - tickMs <= 0) {
          clearInterval(intervalId);
          return 0;
        }

        return prevTime - tickMs;
      });
    }, tickMs);
  }, [tickMs, setTimeRemaining]);

  return timeRemaining;
};

export const useCountDownSeconds = (
  /** Length of the countdown in seconds */
  timeSeconds: number,
  /** Time between steps in seconds */
  tickSeconds = 1,
): number => {
  const timeMs = useCountDown(timeSeconds * 1000, tickSeconds * 1000);
  return Math.ceil(timeMs / 1000);
};
